import type { Dispatch, FC, ReactNode } from 'react';
import { createContext, useContext, useReducer } from 'react';

import { TeamMemberRole } from '__generated__/GQL';

import { Action, memberInformationRoleReducer, State } from './reducer';

type Context = State & {
  dispatch: Dispatch<Action>;
};

interface MemberInviteProviderProps {
  children: ReactNode;
}

const MemberRoleTransitionContext = createContext<Context | undefined>(
  undefined,
);

export const useMemberRoleTransitionState = (): Context => {
  const context = useContext(MemberRoleTransitionContext);

  if (!context) {
    throw new Error(
      'useMemberRoleTransitionState must be used within a <MemberRoleTransitionProvider/>',
    );
  }

  return context;
};

export const MemberRoleTransitionProvider: FC<MemberInviteProviderProps> = ({
  children,
}) => {
  const [state, dispatch] = useReducer(memberInformationRoleReducer, {
    isFreeRolesOnly: false,
    memberRole: {
      role: TeamMemberRole.Accountant,
    },
  });

  const context = {
    ...state,
    dispatch,
  } satisfies Context;

  return (
    <MemberRoleTransitionContext.Provider value={context}>
      {children}
    </MemberRoleTransitionContext.Provider>
  );
};
